export type DividerSpacing = 'small' | 'medium' | 'large';

const DIVIDER_SPACING_THEME_UNITS: Record<DividerSpacing, number> = {
  small: 1,
  medium: 2,
  large: 4,
};

export function normalizeDividerSpacing(value: unknown): DividerSpacing {
  if (value === 'small' || value === 'medium' || value === 'large') {
    return value;
  }
  return 'medium';
}

export function dividerSpacingSx(spacing?: DividerSpacing) {
  const my = DIVIDER_SPACING_THEME_UNITS[normalizeDividerSpacing(spacing)];
  return { my };
}
